import { render, staticRenderFns } from "./RMList.vue?vue&type=template&id=2932cfbf"
import script from "./RMList.vue?vue&type=script&lang=js"
export * from "./RMList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports